const isEmpty = value => value === undefined || value === null || value === '';
const join = (rules) => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[0 /* first error */];
import _ from 'underscore';

import moment from 'moment';
import i18next from "i18next"


export function isValidFTPURL(value) {
	var AddressRegex = /^(([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])(\.(?!$)|(?=$))){4}$/;
	var HostnameRegex = /^([a-z0-9]+\.)?[a-z0-9][a-z0-9-]*((\.[a-z]{2,6})|(\.[a-z]{2,6})(\.[a-z]{2,6}))$/i;

	if (!isEmpty(value) && (!AddressRegex.test(value) && !HostnameRegex.test(value))) {
		return i18next.t('validations.ftp_unvalid');
	}
	return false;

}

export function email(value) {

	if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
		return i18next.t('validations.email_invalid')
	}
	return false;
}

export function isGPS(value) {

	if (!isEmpty(value) && !/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(value)) {
		return i18next.t('validations.gps_unvalid')
	}
	return false;
}

export function isRightDate(value) {

	if (moment(value, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm') == 'Invalid date' || isEmpty(value)) {
		return i18next.t('validations.invalid_date')
	}
	return false;
}

export function required(value) {

	if (isEmpty(value) || value == null) {
		return i18next.t('validations.required');
	}
	return false;
}

export function noSpaces(value) {
	if (!isEmpty(value) && value.indexOf(' ') > -1) {
		return i18next.t('validations.no_spaces');
	}
	return false;
}

export function isValidNumber(value) {
	var re = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,20}$/;
	if (!isEmpty(value) && re.test(value) == false) {
		return i18next.t('validations.international_num');
	}
	return false;
}

export function isValidEQUIPSN(value) {
	// Format: 61PT00539C-100000 (majuscules et chiffres uniquement, avec tiret)
	// Exemple: 61PT00539C-100144
	var re = /^[A-Z0-9]+-[A-Z0-9]+$/;
	if (!isEmpty(value) && re.test(value) == false) {
		return i18next.t('validations.equipsn_invalid');
	}
	return false;
}

export function linuxUserRules(value) {
	var re = /^[a-z]{1}[a-z0-9]+([-_][a-z0-9]+)?$/;
	if (!isEmpty(value) && re.test(value) == false) {
		return i18next.t('validations.linux_user_rules');
	}
	return false;
}

export function noSpecialChars(value) {
	var re = /[~`!#$%\^&*+=\-\[\]\\';,{}|\\":<>\?\.]/g
	if (!isEmpty(value) && re.exec(value) != null) {
		return i18next.t('validations.special_chars_forbidden')
	}
	return false;
}


export function userNoSpecialChars(value) {
	var re = /[~`!#$%\^&*+=\-\[\]\\';,{}|\\":<>\?]/g
	if (!isEmpty(value) && re.exec(value) != null) {
		return i18next.t('validations.special_chars_forbidden')
	}
	return false;
}


export function minLength(min) {
	return value => {
		if (!isEmpty(value) && value.length < min) {
			return i18next.t('validations.at_least', {min});
		}
		return false;
	};
}


export function maxLength(max) {
	return value => {
		if (!isEmpty(value) && value.length > max) {
			return i18next.t('validations.not_greater_than', {max})
		}
		return false;
	};
}


export function IDPTU_LENGTH(value) {

	if (!isEmpty(value) && value.length > 9 && /^[0-9]+$/gm.exec(value) != null) {
		return i18next.t('validations.idptu_invalid');
	}
	return false;
}



export function integer(value) {
	if (!Number.isInteger(Number(value))) {
		return i18next.t('validations.integer');
	}
	return false;
}

export function oneOf(enumeration) {
	return value => {
		if (!~enumeration.indexOf(value)) {
			return i18next.t('validations.oneof', {enum:enumeration.join(', ')})
		}
		return false;
	};
}

export function match(field) {
	return (value, data) => {
		if (data) {
			if (value !== data[field]) {
				return i18next.t('validations.match')
			}
			return false;
		}
	};
}

export function createValidator(rulesObj) {
	var errors = {};

	if (Array.isArray(rulesObj) == false) {

		return (data = {}) => {
			const errors = {};
			Object.keys(rulesObj).forEach((key) => {
				const rule = join([].concat(rulesObj[key])); // concat enables both functions and arrays of functions
				const error = rule(data[key], data);
				if (error) {
					errors[key] = error;
				}
			});
			return errors;
		};

	} else {

		return (data = {}) => {

			_.each(rulesObj, (ruleObj) => {

				var group = Object.keys(ruleObj)[0];
				ruleObj = ruleObj[group]

				if (Array.isArray(data[group])) {
					errors[group] = []
					data[group].map((array, index) => {
						errors[group][index] = {}
						Object.keys(ruleObj).forEach((key) => {
							var rule = join([].concat(ruleObj[key]));
							var error = rule(array[key], array);
							errors[group][index][key] = error;
						})
					})

				} else {
					errors[group] = {}
					Object.keys(ruleObj).forEach((key) => {

						var rule = join([].concat(ruleObj[key]));
						var error = rule(data[group][key], data);
						if (error) {
							errors[group][key] = error;
						}

					});

				}
			})

			return errors;
		};

	}
}
